import { Label, Text, TextField } from '@fluentui/react';
import { textProp } from 'global/Application';
import Formatters from 'global/Utility/Formatters';
import { INumberValue, IStringValue } from 'model/FlexibleAttributeModel';
import { useEffect, useState } from 'react';


export enum ENumberFieldControlFormat {
    float,
    int,
    currency,
}

interface IProps {
    [key: string]: any;
    label?: string;
    disabled?: boolean;
    fieldValueOnChange?: (event: any, value: INumberValue | null) => void;
    defaultFieldValue?: INumberValue;
    format?: ENumberFieldControlFormat;
    floatPrecision?: number;
}

const NumberFieldControl = (props: IProps) => {
    const [value, setValue] = useState<string>();

    const floatPrecision = props.floatPrecision ?? 2;

    const setValueWithFormat = (value?: number) => {
        if (value === null || value === undefined) {
            setValue('');
            return;
        }

        if (props.format === ENumberFieldControlFormat.float)
            setValue(value!.toFixed(floatPrecision).toString())
        else if (props.format === ENumberFieldControlFormat.currency)
            setValue(Formatters.ToCurrencyUSD(value!))
        else if (props.format === ENumberFieldControlFormat.int)
            setValue(value!.toString())
        else
            throw new Error('Format not implemented');

    }

    useEffect(() => {
        setValueWithFormat(props.defaultFieldValue ? props.defaultFieldValue.value : props.defaultValue)
    }, [props.defaultFieldValue, props.defaultValue]);

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{value}</Text>
        </div>;


    const placeHolder = (format?: ENumberFieldControlFormat) => {
        switch (format) {
            case ENumberFieldControlFormat.float:
                return '--.--';
            case ENumberFieldControlFormat.int:
                return '----';
            case ENumberFieldControlFormat.currency:
                return '$--.--';
            default:
                return '-';
        }
    }

    return <TextField
        label={props.label}
        // onChange={props.fieldValueOnChange ? fieldValueOnChange : handleChange}
        placeholder={placeHolder(props.format)}
        onChange={(event, newValue) => { setValue(newValue ?? '') }}
        value={value}
        disabled={props.disabled}
        onBlur={(event) => {
            // Extracting the number from the string
            let tValue = event.target.value.replace(/[^0-9.-]+/g, "");
            let valueNumber = Number(tValue);

            let valid = true;

            // Validate Input
            if (tValue === '')
                valid = false;

            if (isNaN(valueNumber))
                valid = false;

            if (valueNumber > 9999999999999998)
                valid = false;

            if (valueNumber < -9999999999999998)
                valid = false;

            // Formatting
            if (props.format === ENumberFieldControlFormat.float)
                valueNumber = Number(valueNumber.toFixed(floatPrecision))
            else if (props.format === ENumberFieldControlFormat.int)
                valueNumber = Number(valueNumber.toFixed(0))
            else if (props.format === ENumberFieldControlFormat.currency)
                valueNumber = Number(valueNumber.toFixed(2))
            else
                throw new Error('Format not implemented');

            // make payload and rebind the value
            const fieldValue: INumberValue | null = valid
                ? {
                    type: 'number',
                    value: valueNumber
                }
                : null;


            props.fieldValueOnChange?.(event, fieldValue);
            setValueWithFormat(fieldValue?.value)


        }}
        {...props.other}
    />
}

export default NumberFieldControl